import copy from "copy-to-clipboard"
import { Link2 } from "lucide-react"
import toast from "react-hot-toast"
import TeamIcon from "~/images/icons/team.svg?react"
import { Button } from "~/shadcn/ui/button"
import { Card, CardContent } from "~/shadcn/ui/card"

const APPLICATION_LINK = "https://zanoplatform.com/list-your-roster"

// Bottom-of-sidebar module for sharing the talent agency application link
// with agencies that aren't on Zano yet (ZAN-877).
export const TalentAgencyApplicationCard = () => {
  return (
    <Card className="bg-gray10">
      <CardContent className="flex flex-col gap-2 p-4">
        <div className="flex h-9 w-9 items-center justify-center rounded-full bg-[#F9F0F3] text-defaultPrimary">
          <TeamIcon className="w-5" />
        </div>
        <p className="text-sm font-semibold">
          Know a talent agency that should be on Zano?
        </p>
        <p className="text-xs text-gray50">
          Share the application link so they can request access to join the
          marketplace.
        </p>
        <Button
          variant="outline"
          size="sm"
          className="mt-1 h-auto min-h-9 w-full whitespace-normal bg-white py-2 text-sm"
          onClick={() => {
            copy(APPLICATION_LINK)
            toast.success("Application link copied to clipboard")
          }}
        >
          <Link2 className="mr-2 h-4 w-4 shrink-0" />
          Copy link
        </Button>
      </CardContent>
    </Card>
  )
}
